import { IFinancialInformationCategoryResponse } from 'src/api/types/financial-information';
import { timestampToDateFormat } from 'src/utils/timestamp-to-date-format';

export const cellRender = {
    type_names: (data: IFinancialInformationCategoryResponse) => <>{data.type_names.map(item => <p>{item}</p>)}</>,
    updated_at: (data: IFinancialInformationCategoryResponse) => <>{timestampToDateFormat(data.updated_at)}</>,
    created_at: (data: IFinancialInformationCategoryResponse) => <>{timestampToDateFormat(data.created_at)}</>,
};
